module.exports = __webpack_public_path__ + "static/media/Vector_Arrow.0e077acd.svg";